import React, { useState, useEffect } from "react";
import {
  Button,
  Card,
  Col,
  Form,
  message,
  Row,
  Select,
  Space,
  Tabs,
  Upload,
} from "antd";
import styles from "./Inout.module.css";
import { UploadOutlined } from "@ant-design/icons";
import { apiUrl, loginInfo } from "../../config";
import FileSaver from "file-saver";
import { download, getTable, getTableAll } from "../../api/Api";
import { Hospital, initHospital } from "../../models/Hospital";
import { useHistory } from "react-router-dom";
export const Inout: React.FC = () => {
  const token = loginInfo.token;
  const [hospital, setHospital] = useState<Hospital>(initHospital);
  const [hospitalOptions, setHospitalOptions] = useState<any[]>([]);
  const history = useHistory();
  useEffect(() => {
    getHospitalOptions();
  }, []);

  const exportProc = async () => {
    //拿到所有的数据
    let data = await download();
    if(typeof data === "undefined"){
      history.push("/");      
    }
    //定义数据拼接
    //str:table的每一列的标题，即为导出后的csv文件的每一列的标题
    let str =
      "代码,医院,学校,年级,班级,姓名,性别,年龄,CAT,评估结果,检测日期,检测医生,A1,A2,A3,A4,B1,B2,B3,B4,C2,C3,C4,C5";
    //通过循环拿出data数据源里的数据，并塞到str中
    for (const i in data) {
      //如果是第一行,不换行
      str +=
        "\n" +
        data[i].code +
        "," +
        data[i].hospitalName +
        "," +
        data[i].schoolName +
        "," +
        data[i].gradeName +
        "," +
        data[i].className;
      str +=
        "," +
        data[i].name +
        "," +
        data[i].sex +
        "," +
        data[i].age +
        "," +
        data[i].cat +
        "," +
        data[i].result +
        "," +
        data[i].checkDate;
      str +=
        "," +
        data[i].checkName +
        "," +
        data[i].a1 +
        "," +
        data[i].a2 +
        "," +
        data[i].a3 +
        "," +
        data[i].a4;
      str +=
        "," +
        data[i].b1 +
        "," +
        data[i].b2 +
        "," +
        data[i].b3 +
        "," +
        data[i].b4;
      str +=
        "," +
        data[i].c2 +
        "," +
        data[i].c3 +
        "," +
        data[i].c4 +
        "," +
        data[i].c5;
    }
    //Excel打开后中文乱码添加如下字符串解决
    let exportContent = "\uFEFF";
    let blob = new Blob([exportContent + str], {
      type: "text/plain;charset=gb2312",
    });
    //根据数据生成生成文件
    FileSaver.saveAs(blob, "suntoothdata.csv");
  };
  const exportTemplateProc = async () => {
    
    let str =
      "学校名称,学校代码,年级名称,年级代码,班级名称,班级代码,姓名,学号,性别,年龄(岁),年龄(月)\n";
    //通过循环拿出data数据源里的数据，并塞到str中
    //Excel打开后中文乱码添加如下字符串解决
    let exportContent = "\uFEFF";
    let blob = new Blob([exportContent + str], {
      type: "text/plain;charset=gb2312",
    });
    //根据数据生成生成文件
    FileSaver.saveAs(blob, "suntooth-template.csv");
  };

  const props = {
    name: "file",    
    action: `${apiUrl}/upload`,
    headers: {
      authorization: "authorization-text",
      suntoken: token,
      sunhospitalId:hospital.id+'',
    },
    onChange(info) {
      if (info.file.status !== "uploading") {
        //console.log(info.file, info.fileList);
      }
      if (info.file.status === "done") {
        message.success(`${info.file.name} 上传成功`);
      } else if (info.file.status === "error") {
        message.error(`${info.file.name} 上传失败.`);
      }
    },
  };

  const getHospitalOptions = async () => {
    let items: any[] = [];
    let hs: Hospital[] = await getTableAll("hospital");
    if(typeof hs === "undefined"){
      history.push("/");      
    }
    hs.forEach((d) => {
      items.push(
        <Select.Option key={d.id} value={d.id}>
          {d.hospitalName}
        </Select.Option>
      );
    });
    setHospitalOptions(items);
  };
  const onHospitalChange = async (e) => {
    let h: Hospital = await getTable("hospital", e);
    if(typeof h === "undefined"){
      history.push("/");      
    }
    setHospital(h);
  };

  return (
    <div className={styles["workpage"]}>
      <Row justify="space-around">
        <Col>
          <Card title="导入" style={{ width: 300 }}>
            <Space direction="vertical">
              <Select onChange={onHospitalChange} placeholder="请选择检测医院">
                {hospitalOptions}
              </Select>
              <Upload {...props} showUploadList={false}>
                <Button icon={<UploadOutlined />}>导入待检人信息</Button>
              </Upload>
            </Space>
          </Card>
        </Col>
        <Col span={8}>
          <Card title="导出模板" style={{ width: 300 }}>
            <Button type="primary" onClick={exportTemplateProc}>
              导出受检人信息模板
            </Button>
          </Card>
        </Col>
        <Col span={8}>
          <Card title="导出" style={{ width: 300 }}>
            <Button type="primary" onClick={exportProc}>
              导出已检受检人数据
            </Button>
          </Card>
        </Col>
      </Row>
    </div>
  );
};
